export default __webpack_public_path__ + "static/media/hover.f3c2e659.svg";